const SHIP_TYPE_MAP = {
  'lightning-ship-colors': 'lightning',
  'quick-ship-colors': 'quick',
  'build-to-order-colors': 'normal'
};

const getShipType = (colorInput) => {
  for (const cls in SHIP_TYPE_MAP) {
    if (colorInput.closest(`.${cls}`)) return SHIP_TYPE_MAP[cls];
  }
  return null;
};

const handleize = (str) =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const filterSizes = (colorInput) => {
  const shipType = getShipType(colorInput);
  const formId = colorInput.getAttribute('form');
  if (!shipType || !formId) return;

  const colorHandle = handleize(colorInput.value);
  let checkedIsVisible = false;
  let firstVisibleInput = null;

  document.querySelectorAll('.variant-input[data-ship-types]').forEach((div) => {
    const input = div.querySelector(`input[form="${formId}"]`);
    if (!input) return;

    const colorShip = div.getAttribute('data-color-ship');
    let visible;
    if (colorShip) {
      visible = colorShip.split('|').some((pair) => {
        const [c, t] = pair.split(':');
        return c === colorHandle && t === shipType;
      });
    } else {
      const types = div.getAttribute('data-ship-types');
      visible = types.includes(shipType);
    }

    div.style.display = visible ? '' : 'none';

    if (visible) {
      if (!firstVisibleInput) firstVisibleInput = input;
      if (input.checked) checkedIsVisible = true;
    }
  });

  // Auto-select the first visible size if the current selection is hidden
  if (!checkedIsVisible && firstVisibleInput) {
    // Re-assert the correct color before triggering the size change,
    // so the theme reads the right color in _getCurrentOptions()
    if (activeColorInput && !activeColorInput.checked) {
      activeColorInput.checked = true;
    }
    firstVisibleInput.checked = true;
    firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

// Track which color input the user actually clicked so we can
// re-assert it after the theme's _updateInputState overwrites it
// (theme loops all [data-variant-input] and the last duplicate wins)
let activeColorInput = null;

const reassertActiveColor = () => {
  if (activeColorInput && !activeColorInput.checked) {
    activeColorInput.checked = true;
  }
};

const initShipTypeFilter = () => {
  document.querySelectorAll('.variant__input--color-swatch').forEach((input) => {
    input.addEventListener('change', () => {
      activeColorInput = input;
      filterSizes(input);
      requestAnimationFrame(reassertActiveColor);
    });
    if (input.checked) {
      activeColorInput = input;
      filterSizes(input);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShipTypeFilter);
} else {
  initShipTypeFilter();
}

// Root cause: Discount Ninja monitors [data-la-dn-price] and replaces the price block's
// DOM content ~100-280ms after each variant change, always restoring the initial page
// price ($1,387 for 6') regardless of which variant is selected. Simultaneously,
// Product.updatePrice holds a one-time cached reference to [data-product-price] that goes
// stale after DN's first replacement, so theme price writes silently hit a detached node.
//
// Fix: write the correct price immediately on variant:change (always fires, no early-exit
// risk), then watch the DN container — when DN replaces the element we disconnect, write
// the correct price to the new element, and reconnect. No price is hard-coded; we always
// use the variant object from the event. DN has no promotions on these variants ($1,387
// and $1,583 match Shopify admin exactly), so writing variant.price is always correct.

(function() {
  var currentVariant = null;
  var priceObserver = null;
  var priceAnchor = null;

  function writePrice(variant) {
    var el = document.querySelector('[data-product-price]');
    if (el && variant) {
      el.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    }
  }

  function initObserver() {
    priceAnchor = document.querySelector('[data-la-dn-price]') || document.querySelector('.product-block--price');
    if (!priceAnchor) return;

    priceObserver = new MutationObserver(function() {
      if (!currentVariant) return;
      priceObserver.disconnect();
      writePrice(currentVariant);
      priceObserver.observe(priceAnchor, { childList: true, subtree: true });
    });
    priceObserver.observe(priceAnchor, { childList: true, subtree: true });
  }

  document.addEventListener('variant:change', function(evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    currentVariant = variant;
    writePrice(variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
